import { Outlet } from "react-router-dom";
import TopMenu from "../../Dashboard/Menus/TopMenu";

const TopMenuAndContentWrapper = () => {
    return (
        <>
            <TopMenu />
            <Outlet />
        </>
    );
};

export default TopMenuAndContentWrapper;
